

export default class TypeScriptTypesConst {
  static NUMBER = 'number';
  static STRING = 'string';
}
